import O1HD from "../../../engines/gameEngine";
import pawnShopGame from "./pawnShopGame";

const {ccclass, property} = cc._decorator;

@ccclass
export default class pawnShopGameObj extends cc.Component {

    @property({type:cc.Node,displayName:"放大镜"})
    bigGlass:cc.Node = null;

    @property({type:cc.Node,displayName:"遮罩节点"})
    maskNode:cc.Node = null;

    @property({type:cc.Node,displayName:"mask下面的节点"})
    showNode:cc.Node = null;

    @property({type:cc.Node,displayName:"反向遮罩节点"})
    invertedMaskNode:cc.Node = null;

    @property({type:cc.Node,displayName:"mask下面的节点"})
    invertedShowNode:cc.Node = null;

    @property({type:cc.Node,displayName:"瑕疵节点"})
    blemishNode:cc.Node = null;

    @property({type:cc.Label,displayName:"瑕疵数量文本"})
    lb_BlemishCount:cc.Label = null;

    game:pawnShopGame = null;

    bindData(game:pawnShopGame){
        this.game = game;
    }

    //已经被点过的瑕疵
    blemishAry:string[] = [];
    
    onTouchMoveGlass(e:cc.Event.EventTouch){
        let detal:cc.Vec2 = e.getDelta();
        let detalMul:cc.Vec2 = e.getDelta().mul(this.showNode.scale);
        this.bigGlass.x += detal.x;
        this.bigGlass.y += detal.y;
        this.maskNode.x = this.bigGlass.x - 34;
        this.maskNode.y = this.bigGlass.y + 50.5;
        this.showNode.x -= detalMul.x;
        this.showNode.y -= detalMul.y;
        this.invertedMaskNode.x = this.bigGlass.x - 34;
        this.invertedMaskNode.y = this.bigGlass.y + 50.5;
        this.invertedShowNode.x -= detal.x;
        this.invertedShowNode.y -= detal.y;   
    }

    start(): void {
        this.initBlemish();
        this.updateBlemishCount();
        this.closeGlass();
    }

    checkCanOpenGlass(){
        return this.blemishAry.length < 3;
    }

    openGlass(){
        let invertedMask = this.invertedMaskNode.getComponent(cc.Mask);
        invertedMask.enabled = true;
        this.maskNode.active  = true;
        this.bigGlass.active = true;
        this.bigGlass.opacity = 255;
        this.lb_BlemishCount.node.active = true;
        this.blemishAddEvent();
        this.glassAddEvent();
    }

    closeGlass(){
        let invertedMask = this.invertedMaskNode.getComponent(cc.Mask);
        invertedMask.enabled = false;
        this.maskNode.active  = false;
        this.bigGlass.active = false;
        this.lb_BlemishCount.node.active = false;
        this.blemshRemoveEvent();
        this.glassRemoveEvent();
    }

    closeGlassAni(){
        let invertedMask = this.invertedMaskNode.getComponent(cc.Mask);
        invertedMask.enabled = false;
        this.maskNode.active  = false;
        cc.tween(this.bigGlass).to(0.2,{opacity:0}).call(()=>{
            this.bigGlass.active = false;
        }).start();
        this.lb_BlemishCount.node.active = false;
        this.blemshRemoveEvent();
        this.glassRemoveEvent();
    }

    glassAddEvent(){
        this.bigGlass.getChildByName("glass").on("touchmove",this.onTouchMoveGlass,this);
    }

    glassRemoveEvent(){
        this.bigGlass.getChildByName("glass").off("touchmove",this.onTouchMoveGlass,this);
    }

    blemishAddEvent(){
        this.blemishNode.children.forEach((n:cc.Node,index:number)=>{
            n.on("touchend",this.onBlemishClick,this);
        });
    }

    blemshRemoveEvent(){
        this.blemishNode.children.forEach((n:cc.Node,index:number)=>{
            n.off("touchend",this.onBlemishClick,this);
        });
    }

    //点击瑕疵
    async onBlemishClick(e:cc.Event.EventTouch){
        console.log("点击瑕疵");
        let node:cc.Node = e.target;
        let sibling = Number(node.name);
        if(this.blemishAry.includes(node.name)){
            // O1HD.getModules().uiControlModule.showMessageBox("该瑕疵")
            return;
        }
        let length = this.blemishAry.length;
        if(length >= 3){
            return;
        }
        this.blemishAry.push(node.name);
        length = this.blemishAry.length;
        this.updateBlemishCount();
        // 转圈动画 以及触发相应的对话和减钱
        await this.circleAni(node);
        if(length >= 3){
            this.closeGlassAni();
            this.game.hidelowerBtns();
        }
        this.game.openOneBlemish(sibling,this.bigGlass);
    }

    //更新瑕疵数量
    updateBlemishCount(){
        this.lb_BlemishCount.string = `瑕疵数量：${this.blemishAry.length}/3`;
    }

    //初始化瑕疵
    initBlemish(){
        this.blemishNode.children.forEach((n:cc.Node)=>{
            let yuan :cc.Sprite = n.getChildByName("yuan").getComponent(cc.Sprite);
            yuan.fillRange = 0;
        });
    }
    
    //圆圈动画
    circleAni(node:cc.Node){
        return new Promise<void>(resolve=>{
            let yuan = node.getChildByName("yuan").getComponent(cc.Sprite);
            cc.tween(yuan).to(0.2,{fillRange:1}).delay(1).call(resolve).start();
        });
    }

}
